import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    root: {
        position: 'relative' as const,
        flexGrow: 1,
        backgroundColor: theme?.app?.applicationColors.enumColors.offWhite ||
            '#F3F3F3'
    },
    buttonToolbar: {
        position: 'absolute' as const,
        top: '2.5rem',
        left: '2.5rem',
        zIndex: 100,
        flexBasis: 'auto' as const
    },
    usersContainer: {
        flexGrow: 1,
        padding: '1.5rem 0'
    },
    usersGridContainer: { minHeight: '420px' },
    exportButton: {
        position: 'absolute' as const,
        top: '1.5rem',
        right: '2rem',
        zIndex: 10
    },
    exportIcon: {
        height: '16px',
        width: '24px'
    },
    selectedUserContainer: { padding: '0 2rem' },
    noSelectedUser: {
        paddingTop: '3rem',
        alignSelf: 'center' as const,
        justifySelf: 'center' as const
    },
    usersIcon: {
        height: '90px',
        width: '90px',
        paddingBottom: '1.5rem'
    },
    notificationError: {
        background: theme?.app?.applicationColors.failure ||
            '#FA5252',
        width: '100%',
        padding: '.5rem 1rem',
        color: '#FFF'
    }
});